import { useEffect } from 'react';
import { Frame } from './styled';
import { OneColumn } from '@/components/Layout';
import LoadingOverlay from '@/components/LoadingOverlay';
import { useQuery } from '@tanstack/react-query';
import { userOtp } from '@simplywallst/services';
import { withAuth } from '@utilities/queries';
import If from '@/components/If';

interface Props {
  id?: string;
  otp?: string;
  isOtpRequired?: boolean;
  otpGenerationTime?: number;
  url: string;
  loadingText: string;
  unMountOperations?: () => void;
  handleOtpGeneration?: () => void;
  handleIFrameRouteChangingEvent: (data: { path: string }) => void;
}

export const IFrame = (props: Props) => {
  function getHostName(url: string) {
    const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
    if (
      match !== null &&
      match.length > 2 &&
      typeof match[2] === 'string' &&
      match[2].length > 0
    ) {
      return match[2];
    } else {
      return null;
    }
  }
  function onPostMessage(event: MessageEvent) {
    try {
      if (!event || !event.origin) {
        console.warn('Invalid event or origin', event);
        return;
      }
      const originalDomain = getHostName(props.url);
      const incomingDomain = getHostName(event.origin);
      if (originalDomain !== incomingDomain) {
        console.warn(
          `Incoming: ${incomingDomain} and Orginal Domain: ${originalDomain} doesnot match`
        );
        return;
      }
      if (
        event.data &&
        event.data.type &&
        event.data.type === 'route.changing' &&
        event.data.path &&
        !event.data.path.includes('calculation')
      ) {
        props.handleIFrameRouteChangingEvent &&
          props.handleIFrameRouteChangingEvent(event.data);
      } else {
        console.log('Received event not matching route.changing', event.data);
      }
    } catch (err) {
      console.error('Failed to process post message from Child Frame', err);
    }
  }
  useEffect(() => {
    window.addEventListener('message', onPostMessage, false);
    return () => {
      props.unMountOperations && props.unMountOperations();
      window.removeEventListener('message', onPostMessage);
    };
  }, []);

  const { isLoading, data } = useQuery({
    queryKey: ['api/user/otp', props.id],
    queryFn: async () => {
      try {
        const response = await withAuth(userOtp);
        return response.data.data;
      } catch (error) {
        return undefined;
      }
    },
    staleTime: 5400000,
  });
  let formattedUrl = props.url;
  if (typeof data !== 'undefined') {
    formattedUrl = `${props.url}?auth_otp=${data.token}`;
  }

  return (
    <OneColumn>
      <If
        conditions={{
          loading: isLoading,
          ready: !isLoading,
        }}
      >
        {{
          loading: <LoadingOverlay loadingText={props.loadingText} />,
          ready: <Frame data-cy-id="legacy-portal" src={formattedUrl} />,
        }}
      </If>
    </OneColumn>
  );
};

IFrame.defaultProps = {
  id: '',
};
